// @flow
import * as React from 'react'

export function ClearButton (): React.Node {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#F2472A" stroke="white"/>
      <path d="M12.9353 6.9563L6.95703 13.1251" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.95533 6.95581L12.9336 13.1247" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
